import { render, staticRenderFns } from "./bfhs-tile.vue?vue&type=template&id=d2e314cc&scoped=true&"
import script from "./bfhs-tile.vue?vue&type=script&lang=js&"
export * from "./bfhs-tile.vue?vue&type=script&lang=js&"
import style0 from "./bfhs-tile.vue?vue&type=style&index=0&id=d2e314cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e314cc",
  null
  
)

export default component.exports